export class BuildingUnit {
  id: number;
  buildingLevelId: number;
  buildingUnitTypeId: number;
  name: string;
  description: string;
}



// WEBPACK FOOTER //
// ./src/app/core/models/building-unit.ts